import { render, staticRenderFns } from "./ReassignItemsPanel.vue?vue&type=template&id=289e9b3e&scoped=true"
import script from "./ReassignItemsPanel.vue?vue&type=script&lang=js"
export * from "./ReassignItemsPanel.vue?vue&type=script&lang=js"
import style0 from "./ReassignItemsPanel.vue?vue&type=style&index=0&id=289e9b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289e9b3e",
  null
  
)

export default component.exports